/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesLayout.scss';

import { object, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

import PreferencesNavigationContainer from 'components/layouts/Navigation/PreferencesNavigationContainer';
import PreferencesBar from 'components/layouts/Preferences/PreferencesBar';
import Toaster from 'components/layouts/Toaster/Toaster';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import {
  getDefaultPreferencesRequestStatus,
  getHasReceivedPrimaryData
} from 'state/requests/RequestStatusSelectors';
import {
  getThemeName,
  isMobile,
  isSalesforceRepEnabled
} from 'state/view/ViewSelectors';
import {
  getCustomerPreferences,
  getCustomerPreferencesV2
} from 'services/Rest';
import { getPathnameEnd } from 'services/Externals';
import { getHasMissingDOB } from 'state/view/ViewSelectors';
import {
  addLRNEnabled,
  owned529OnlyBrandingEnabled
} from 'services/FeatureFlags';
import {
  getThemeNameFromAccounts,
  mapProductTypeToiiFooterBoolean
} from 'state/account/AccountSelectors';
import { residentialAddressEnabled } from 'services/FeatureFlags';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';
import AAMFooterContainer from './Footer/FooterUtil';
import { hasAppLoaded } from 'state/analytics/analyticsSelectors';
import { legalReferenceNumbers } from 'services/Content';

class PreferencesLayout extends React.Component {
  constructor(props) {
    super(props);
    const { requestStatus } = props;
    const { customerPreferences } = requestStatus;
    if (customerPreferences !== REQUEST_STATES.received) {
      if (residentialAddressEnabled()) {
        getCustomerPreferencesV2();
      } else {
        getCustomerPreferences();
      }
    }
  }

  componentDidMount() {
    document.body.style.backgroundColor = '#E3E6E8';
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = null;
  }

  render() {
    const {
      appLoaded,
      isMobileApp,
      footerProductTypes,
      isSalesforceRepEnabled,
      requestStatus,
      themeName,
      hasMissingDOB,
      hasReceivedPrimaryData
    } = this.props;
    const hasFullPageError = Object.values(requestStatus).some(
      (status) => status === REQUEST_STATES.error
    );
    const isPreferencesBarLoading = Object.values(requestStatus).some(
      (status) => status !== REQUEST_STATES.received
    );

    if (!hasReceivedPrimaryData) {
      return <PageLoadingSpinner name={'Profile'} />;
    }

    return (
      <div className="preference-layout-container-page">
        {hasFullPageError && (
          <Redirect
            to={
              window.location
                ? `${getPathnameEnd(window.location.pathname)}/error`
                : '/error'
            }
          />
        )}

        {hasMissingDOB && <Redirect to="/missing-information" />}
        <div className={`preferences-layout-container ${themeName}`}>
          {!isSalesforceRepEnabled && (
            <PreferencesBar
              hasError={hasFullPageError}
              isPreferencesBarLoading={isPreferencesBarLoading}
            />
          )}
          {hasReceivedPrimaryData && (
            <PreferencesNavigationContainer
              isSalesforceRepEnabled={isSalesforceRepEnabled}
              hasError={hasFullPageError}
            />
          )}
          <Toaster />
        </div>
        {addLRNEnabled() && (
          <div className="preferences-lrn-layout-footer">
            <LegalReferenceNumber
              providedLegalNumber={legalReferenceNumbers.PROFILE_PAGE_LRN}
            />
          </div>
        )}

        {/* TODO: Need to fix console error as `div cannot appear as a descendant of p in AAMFooterContainer*/}
        {!isSalesforceRepEnabled && (
          <div className={addLRNEnabled() ? 'lrn-footer' : ''}>
            <AAMFooterContainer
              isMobileParam={isMobileApp}
              footerProductTypes={footerProductTypes}
              appLoaded={appLoaded}
            />
          </div>
        )}
      </div>
    );
  }
}

PreferencesLayout.propTypes = {
  requestStatus: object.isRequired,
  themeName: string
};

const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  appLoaded: hasAppLoaded(state),
  isMobileApp: isMobile(state),
  isSalesforceRepEnabled: isSalesforceRepEnabled(state),
  requestStatus: getDefaultPreferencesRequestStatus(state),
  themeName: owned529OnlyBrandingEnabled()
    ? getThemeNameFromAccounts(state)
    : getThemeName(state),
  hasMissingDOB: getHasMissingDOB(state),
  hasReceivedPrimaryData: getHasReceivedPrimaryData(state)
});

export default withRouter(connect(mapStateToProps)(PreferencesLayout));
